// v10/src/config/realtime.js
//
// Frecuencias de polling configurables vía variables de entorno.
// Defaults pensados para producción normal.
// Para demo presencial se pueden ajustar via REACT_APP_POLL_*.
//
// Migración a SSE/WebSockets pendiente — ver xlsx item M8.
// Cuando se migre, este archivo se elimina o se reduce a fallback.

const parseMs = (envVar, defaultMs) => {
  const parsed = parseInt(envVar, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : defaultMs;
};

const SAFE_FALLBACK_MS = 60000;

const baseConfig = {
  // Notificaciones del admin (la campanita).
  // Usado en NotificationManager.js
  notifications: parseMs(process.env.REACT_APP_POLL_NOTIFICATIONS_MS, 30000),

  // Autorizaciones de vuelo pendientes para instructores.
  // Usado en admin/AdminFlightAuth.js y admin/AdminPanel.js
  flight_auth: parseMs(process.env.REACT_APP_POLL_FLIGHT_AUTH_MS, 15000),

  // Estado de aeronaves (operativa, AOG, MEL).
  // Usado en AircraftSelector.js
  aircraft: parseMs(process.env.REACT_APP_POLL_AIRCRAFT_MS, 15000),

  // Espera de respuesta del instructor a una solicitud de autorización.
  // Usado en CompletionScreen.js (lado del piloto esperando confirmación)
  flight_auth_pilot: parseMs(process.env.REACT_APP_POLL_FLIGHT_AUTH_PILOT_MS, 5000),

  // Banner de mantenimiento programado.
  // Usado en MaintenanceBanner.js
  maintenance: parseMs(process.env.REACT_APP_POLL_MAINTENANCE_MS, 30000),

  // Stock de repuestos (A8).
  // Usado en admin/inventory/InventoryTab.js (dashboard + listado).
  inventory: parseMs(process.env.REACT_APP_POLL_INVENTORY_MS, 30000),
};

// Proxy con fallback seguro: si alguien accede a una propiedad inexistente
// (ej: typo POLLING_INTERVALS.aircrafts en vez de .aircraft), devuelve un
// fallback razonable y loggea el error en lugar de devolver undefined.
//
// Importante: setInterval(fn, undefined) corre el polling cientos de veces
// por segundo, lo cual puede tumbar el backend en minutos.
export const POLLING_INTERVALS = new Proxy(baseConfig, {
  get(target, prop) {
    // Symbol y propiedades internas del objeto pasan sin warning
    if (typeof prop === 'symbol' || prop in target) {
      return target[prop];
    }
    // eslint-disable-next-line no-console
    console.error(
      `[Condor360] Polling interval inexistente: "${String(prop)}". ` +
      `Usando fallback de ${SAFE_FALLBACK_MS}ms. ` +
      `Propiedades válidas: ${Object.keys(target).join(', ')}`
    );
    return SAFE_FALLBACK_MS;
  }
});

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.log('[Condor360] Polling intervals (ms):', baseConfig);
}
